<div>
  <div class="strong-text">{{ uiService.productName }} is not authorized to manage IAM resources on your behalf.</div>
  <div>You will need to apply a CloudFormation template to create these resources yourself.</div>
  <div class="padding-top">
    If you have previously applied a CloudFormation template to manage IAM resources from account
    {{ sourceAwsAccountId }} in region {{ sourceRegion }}, update your existing CloudFormation stack. Otherwise, create
    a new CloudFormation stack.
  </div>
  <div class="padding-top">
    <a [href]="uiService.cloudFormationInstructionsUrl" target="_blank">Click here</a> for help using CloudFormation.
  </div>
  <div class="padding-top details-section">
    <div class="detail-label">Template:</div>
    <div class="command-block">
      <button
        class="copy-btn"
        [copy-clipboard]="manualResourceTemplateUrl"
        (copied)="copyFeedback.onCopied('template')"
      >
        <i
          class="fa-utility fa-semibold"
          [class.fa-copy]="!copyFeedback.copiedStates['template']"
          [class.fa-check]="copyFeedback.copiedStates['template']"
        ></i>
        {{ copyFeedback.copiedStates['template'] ? 'Copied!' : 'Copy URL' }}
      </button>
      <pre><code>{{ manualResourceTemplateName }}</code></pre>
    </div>
    <div class="detail-label">Suggested Stack Name:</div>
    <div class="command-block">
      <button class="copy-btn" [copy-clipboard]="suggestedStackName" (copied)="copyFeedback.onCopied('stackName')">
        <i
          class="fa-utility fa-semibold"
          [class.fa-copy]="!copyFeedback.copiedStates['stackName']"
          [class.fa-check]="copyFeedback.copiedStates['stackName']"
        ></i>
        {{ copyFeedback.copiedStates['stackName'] ? 'Copied!' : 'Copy' }}
      </button>
      <pre><code>{{ suggestedStackName }}</code></pre>
    </div>
    <div><span class="strong-text">AWS Account:</span> {{ targetAwsAccountId }}</div>
    <div><span class="strong-text">Region:</span> {{ targetRegion }}</div>
  </div>
</div>
